import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Game } from '../../../models/communication/app-state.model';

@Component({
    selector: 'app-game-selection',
    standalone: true,
    imports: [CommonModule, FormsModule],

    templateUrl: './game-selection.component.html',
    styleUrl: './game-selection.component.scss'
})
export class GameSelectionComponent implements OnInit {
    @Input()
    availableGames?: Game[];

    @Input()
    unfinishedGame?: Game;

    @Input()
    currentGameId?: Game['id'];

    @Input()
    showBackButton = true;

    @Output()
    readonly backClicked = new EventEmitter();

    @Output()
    readonly gameSelected = new EventEmitter<{ gameId: Game['id']; isUnfinished?: boolean }>();

    protected toggleButtonHidden = false;
    protected virtualSelected = false;

    protected filteredGames: Game[] = [];

    ngOnInit(): void {
        if (!this.availableGames) {
            // eslint-disable-next-line no-console
            console.error('No available games');
            return;
        }

        if (this.toggleNeeded(this.availableGames)) {
            // If the current game is virtual, we need to show it
            // together with the other virtual games at start
            if (this.currentGameId !== undefined) {
                this.virtualSelected = this.availableGames.find((game) => game.id === this.currentGameId)?.isVirtual ?? false;
            }
            this.updateFilteredGames(this.virtualSelected);
        } else {
            this.toggleButtonHidden = true;
            this.filteredGames = this.availableGames;
        }
    }

    protected updateFilteredGames(toggle: boolean): void {
        this.virtualSelected = toggle;
        this.filteredGames = this.filterGames('isVirtual', this.virtualSelected);
    }

    /**
     * Filters the list of available games based on a specified property and its boolean value.
     */
    private filterGames(property: keyof Game, flag: boolean): Game[] {
        return this.availableGames?.filter((game) => game[property] === flag) ?? [];
    }

    /**
     * If there are no virtual games or all games are virtual,
     * we show all the available games and hide the toggle button
     */
    private toggleNeeded(availableGames: Game[]): boolean {
        const availableVirtualGamesCount = availableGames.filter((game) => game.isVirtual).length;
        return availableVirtualGamesCount !== 0 && availableVirtualGamesCount !== availableGames.length;
    }
}
